export default __webpack_public_path__ + "static/media/margin-loan.6cb86706.png";